
export const setAllReports = ({ dispatch, commit }, list ) => {
  commit('ALL_REPORTS', list)
  dispatch('resetFirstTimeLoad', list.map(a => false))
  dispatch('resetMainListQuickFilters', list.map(a => []))
  dispatch('resetQuickFiltersDatesFrom', list.map(a => []))
  dispatch('resetQuickFiltersDatesTo', list.map(a => []))
  dispatch('resetQuickFiltersGroups', list.map(a => []))
  dispatch('resetSort', {
    sortFieldList: list.map(a => ''),
    sortFieldIdList: list.map(a => 0),
    sortOrderList: list.map(a => 0)
  })
  dispatch('resetPage', {
    pageList: list.map(a => 1),
    rowsList: list.map(a => 25)
  })
  dispatch('setHardLoad', list.map(a => 0))
  dispatch('setSoftReload', list.map(a => 0))
  dispatch('resetColumns', list.map(a => []))
}

export const resetFirstTimeLoad = ({ commit }, list ) => {
  commit('FIRST_TIME_LOAD', list)
}

export const setFirstTimeLoad = ({ commit, getters }, { bool, id } ) => {
  let a = [...getters.getFirstTimeLoad]
  if (a[id]) {
    a[id] = bool
    commit('FIRST_TIME_LOAD', a)
  }
}

export const resetMainListQuickFilters = ({ commit }, list ) => {
  commit('MAIN_LIST_QUICK_FILTER', list)
}

export const setMainListQuickFilters = ({ commit, getters }, { list, id } ) => {
  let a = [...getters.getMainListQuickFilter]
  if (a[id]) {
    a[id] = list
    commit('MAIN_LIST_QUICK_FILTER', a)
  }
}

export const resetQuickFiltersDatesFrom = ({ commit }, list ) => {
  commit('QUICK_FILTERS_DATES_FROM', list)
}

export const setQuickFiltersDatesFrom = ({ commit, getters }, { list, id } ) => {
  let a = [...getters.getQuickFiltersDatesFrom]
  if (a[id]) {
    a[id] = list
    commit('QUICK_FILTERS_DATES_FROM', a)
  }
}

export const resetQuickFiltersDatesTo = ({ commit }, list ) => {
  commit('QUICK_FILTERS_DATES_TO', list)
}

export const setQuickFiltersDatesTo = ({ commit, getters }, { list, id } ) => {
  let a = [...getters.getQuickFiltersDatesTo]
  if (a[id]) {
    a[id] = list
    commit('QUICK_FILTERS_DATES_TO', a)
  }
}

export const resetQuickFiltersGroups = ({ commit }, list ) => {
  commit('QUICK_FILTERS_GROUPS', list)
}

export const setQuickFiltersGroups = ({ commit, getters }, { list, id } ) => {
  let a = [...getters.getQuickFiltersGroups]
  if (a[id]) {
    a[id] = list
    commit('QUICK_FILTERS_GROUPS', a)
  }
}

export const resetSort = ({ commit }, { sortFieldList, sortFieldIdList, sortOrderList }) => {
  if (sortOrderList.every(sort => sort >= -1 && sort <= 1) && sortFieldList.length === sortFieldIdList.length && sortFieldIdList.length === sortOrderList.length) {
    commit('SORT', { 
      sortField: sortFieldList, 
      sortFieldId: sortFieldIdList, 
      sortOrder: sortOrderList 
    })
  }
}

export const setSort = ({ commit, getters }, { sortField, sortFieldId, sortOrder, id }) => {
  if (sortOrder >= -1 && sortOrder <= 1) {
    let a = [...getters.getSortField], b = [...getters.getSortFieldId], c = [...getters.getSortOrder]
    if (a[id] && b[id] && c[id]) {
      a[id] = sortField
      b[id] = sortFieldId
      c[id] = sortOrder
      commit('SORT', { 
        sortField: a, 
        sortFieldId: b, 
        sortOrder: c 
      })
    }
  }
}

export const resetPage = ({ commit }, { pageList, rowsList }) => {
  if (pageList.length === rowsList.length) {
    commit('PAGE', { 
      page: pageList, 
      rows: rowsList 
    })
  }
}

export const setPage = ({ commit, getters }, { page, rows, id }) => {
  let a = [...getters.getPage], b = [...getters.getRows]
  if (a[id] && b[id]) {
    a[id] = page
    b[id] = rows
    commit('PAGE', { 
      page: a, 
      rows: b 
    })
  }
}

export const setHardLoad = ({ commit }, list) => {
  commit('HARD_LOAD', list)
}

export const addHardLoad = ({ commit, getters }, { id }) => {
  let a = [...getters.getHardLoad]
  if (a[id]) {
    a[id] += 1
    commit('HARD_LOAD', a)
  }
}

export const setSoftReload = ({ commit }, list) => {
  commit('SOFT_RELOAD', list)
}

export const addSoftReload = ({ commit, getters }, { id }) => {
  let a = [...getters.getSoftReload]
  if (a[id]) {
    a[id] += 1
    commit('SOFT_RELOAD', a)
  }
}

export const resetColumns = ({ commit }, list) => {
  commit('COLUMNS', list)
}

export const setColumns = ({ commit, getters }, { list, id }) => {
  let a = [...getters.getColumns]
  if (a[id]) {
    a[id] = list
    commit('COLUMNS', a)
  }
}